import React from 'react';
import Pagination from '../../pagination';

interface Props {
  knowledgebases: any;
  knowledgebaseCategories: any;
  pageIndex: any;
  setPageIndex: any;
  showPagination?: boolean;
}

const KnowledgebaseGrid: React.FC<Props> = ({
  knowledgebases,
  knowledgebaseCategories,
  pageIndex,
  setPageIndex,
  showPagination = true,
}) => (
  <div>
    <ul>
      {knowledgebases.content.map((kb, index) => {
        const category = knowledgebaseCategories.filter(
          (c) => c.id === kb.category
        );

        return (
          <li
            key={index}
            onClick={() =>
              (window.location.href =
                '/knowledgebase/' + encodeURIComponent(kb.title))
            }
          >
            <span>
              <i className="fas fa-arrow-alt-circle-right" />
            </span>
            <div>
              <span className="category">{category?.[0]?.text}</span>
              <span>{kb.title}</span>
            </div>
          </li>
        );
      })}
    </ul>
    {showPagination && (
      <Pagination
        onPageChange={(p) => setPageIndex(p)}
        totalCount={knowledgebases.totalElements}
        siblingCount={1}
        currentPage={pageIndex}
        pageSize={10}
      />
    )}
    {/* language=CSS */}
    <style jsx>{`
      ul {
        list-style: none;
        padding: 0;
      }

      ul li {
        display: flex;
        gap: 1rem;
        margin-bottom: 0.5rem;
        font-family: 'Volvo Novum', sans-serif;
        font-size: 14px;
        cursor: pointer;
        padding: 1rem;
      }

      ul li:hover {
        background-color: #eee;
        transition: background-color 0.2s linear;
      }

      ul li span {
        display: block;
      }

      ul li span.category {
        text-transform: uppercase;
        font-size: 12px;
        color: #777;
      }
    `}</style>
  </div>
);

export default KnowledgebaseGrid;
